"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackerImpl = void 0;
var Error_1 = require("./IO/Output/Error");
var AxiosRequest_1 = require("./Infrastructure/AxiosRequest");
var UnknownError_1 = require("../utils/UnknownError");
/**
 * <h4>Tracker implementation</h4>
 *
 * Documentation of Tracker module is in interface description {@link TrackerInterface}
 */
var TrackerImpl = /** @class */ (function () {
    /**
     * @param config Customer configuration
     */
    function TrackerImpl(config) {
        this.config = config;
        this.apiRequest = new AxiosRequest_1.AxiosTrackRequest(config);
    }
    TrackerImpl.prototype.sendProductClick = function (productClick) {
        var url = TrackerImpl.getClickUrl(productClick.id);
        this.apiRequest.sendClick(url)
            .catch(function (reason) {
            var _a, _b, _c;
            throw new Error_1.ProductClickError((_c = (_b = (_a = reason.response) === null || _a === void 0 ? void 0 : _a.data.data) === null || _b === void 0 ? void 0 : _b.error_message) !== null && _c !== void 0 ? _c : UnknownError_1.UnknownError.messageByAxiosError(reason));
        });
    };
    TrackerImpl.prototype.sendProductView = function (productView) {
        var url = this.getViewsUrl(productView.id);
        this.apiRequest.sendView(url)
            .catch(function (reason) {
            var _a, _b, _c;
            throw new Error_1.ProductViewError((_c = (_b = (_a = reason.response) === null || _a === void 0 ? void 0 : _a.data.data) === null || _b === void 0 ? void 0 : _b.error_message) !== null && _c !== void 0 ? _c : UnknownError_1.UnknownError.messageByAxiosError(reason));
        });
    };
    TrackerImpl.getRandomNumber = function () {
        return Math.floor(Number(new Date()) / 1000 * Math.random());
    };
    TrackerImpl.prototype.getTransactionPayload = function (transaction) {
        var basket = transaction.basket.map(function (basketPosition) {
            var _a;
            return {
                'prod': basketPosition.productId,
                'prc': basketPosition.price,
                'qty': basketPosition.quantity,
                'trn': transaction.transactionId,
                'crn': (_a = transaction.currency) !== null && _a !== void 0 ? _a : ''
            };
        });
        return new URLSearchParams([
            ['c', this.config.getCustomer()],
            ['a', 'sell'],
            ['u', ''],
            ['ut', ''],
            ['t', transaction.transactionId],
            ['trn', JSON.stringify(basket)]
        ]);
    };
    TrackerImpl.prototype.getTrackingPayload = function (transaction, transactionPosition) {
        var _a;
        return new URLSearchParams([
            ['c', this.config.getCustomer()],
            ['a', 'purchase'],
            ['u', ''],
            ['ut', ''],
            ['p', transactionPosition.productId],
            ['v', transactionPosition.price],
            ['q', transactionPosition.quantity],
            ['t', transaction.transactionId],
            ['c3', (_a = transaction.currency) !== null && _a !== void 0 ? _a : ''],
            ['m', TrackerImpl.getRandomNumber()],
            ['ref', typeof location !== 'undefined' ? location.href : '']
        ]);
    };
    TrackerImpl.prototype.sendOnlyTransaction = function (transaction) {
        var transactionPayload = this.getTransactionPayload(transaction);
        var url = "".concat(this.getTransactionUrl(), "?").concat((transactionPayload));
        this.apiRequest.sendTransaction(url)
            .catch(function (reason) {
            var _a, _b, _c;
            throw new Error_1.TransactionError((_c = (_b = (_a = reason.response) === null || _a === void 0 ? void 0 : _a.data.data) === null || _b === void 0 ? void 0 : _b.error_message) !== null && _c !== void 0 ? _c : UnknownError_1.UnknownError.messageByAxiosError(reason));
        });
    };
    TrackerImpl.prototype.sendTransaction = function (transaction) {
        this.sendOnlyTransaction(transaction);
        this.sendTrackingInfo(transaction);
    };
    TrackerImpl.prototype.getTransactionUrl = function () {
        var host = this.config.getHost();
        return "https://rec.".concat(host, "/trn/");
    };
    TrackerImpl.prototype.getTrackingUrl = function () {
        var host = this.config.getHost();
        return "https://rec.".concat(host, "/t.php");
    };
    TrackerImpl.prototype.getViewsUrl = function (productId) {
        var host = this.config.getHost();
        var customerSymbol = this.config.getCustomer();
        var requestParams = new URLSearchParams([
            ['c', customerSymbol],
            ['a', 'view'],
            ['p', productId]
        ]);
        return "https://rec.".concat(host, "/t.php?").concat(requestParams);
    };
    TrackerImpl.getClickUrl = function (id) {
        // todo: błędny link zbierający kliki!
        return "https://www.quarticon.com?".concat(id);
    };
    TrackerImpl.prototype.sendTrackingInfo = function (transaction) {
        var _this = this;
        var basket = transaction.basket;
        basket.forEach(function (transactionPosition) {
            var transactionPositionPayload = _this.getTrackingPayload(transaction, transactionPosition);
            var url = "".concat(_this.getTrackingUrl(), "?").concat(transactionPositionPayload);
            _this.apiRequest.sendTrackingInformation(url)
                .catch(function (reason) {
                var _a, _b, _c;
                throw new Error_1.TransactionError((_c = (_b = (_a = reason.response) === null || _a === void 0 ? void 0 : _a.data.data) === null || _b === void 0 ? void 0 : _b.error_message) !== null && _c !== void 0 ? _c : UnknownError_1.UnknownError.messageByAxiosError(reason));
            });
        });
    };
    return TrackerImpl;
}());
exports.TrackerImpl = TrackerImpl;
//# sourceMappingURL=TrackerImpl.js.map